module.exports = __webpack_public_path__ + "img/AboutFlunder.1a6c6963.jpg";